import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Loader2, MessageSquare, Mail, Smartphone, Sparkles } from 'lucide-react';

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('dentalToken')}` } });
const fmt = (d) => (d ? new Date(d).toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' }) : '');
const KIND = { portal_link: 'Portal link', ecard: 'eCard', form_reminder: 'Form reminder' };

const Msg = ({ m }) => {
  const out = m.direction === 'out';
  const Icon = m.channel === 'email' ? Mail : Smartphone;
  return (
    <div className={`flex ${out ? 'justify-end' : 'justify-start'}`} data-testid={`patient-msg-${m.id}`}>
      <div className={`max-w-[80%] rounded-xl px-3 py-2 text-sm ${out ? 'bg-sky-50 border border-sky-200' : 'bg-white border border-gray-200'}`}>
        <div className="flex items-center gap-1.5 text-[11px] text-gray-500 mb-1">
          <Icon className="h-3 w-3" />{m.channel === 'email' ? 'Email' : 'Text'} · {out ? 'Sent' : 'Received'}
          {m.kind && KIND[m.kind] && <span className="px-1.5 rounded bg-gray-100">{KIND[m.kind]}</span>}
          {m.aiGenerated && <span className="flex items-center gap-0.5 text-violet-600"><Sparkles className="h-3 w-3" />AI</span>}
          {m.status === 'failed' && <span className="text-rose-600 font-semibold">Failed</span>}
        </div>
        {m.subject && <p className="font-semibold text-gray-800">{m.subject}</p>}
        <p className="whitespace-pre-wrap text-gray-800">{m.body}</p>
        <p className="text-[10px] text-gray-400 mt-1">{fmt(m.at)}</p>
      </div>
    </div>
  );
};

export const PatientMessagesTab = ({ patientId }) => {
  const [msgs, setMsgs] = useState(null);
  useEffect(() => {
    setMsgs(null);
    axios.get(`${BACKEND}/api/messages/thread/${patientId}`, auth()).then((r) => setMsgs(r.data.messages || [])).catch(() => setMsgs([]));
  }, [patientId]);
  if (!msgs) return <div className="py-8 text-center"><Loader2 className="h-6 w-6 animate-spin mx-auto text-sky-600" /></div>;
  if (!msgs.length) {
    return (
      <div className="text-center py-10 text-gray-500" data-testid="patient-messages-empty">
        <MessageSquare className="h-10 w-10 mx-auto mb-2 text-gray-300" />No texts or emails with this patient yet.
      </div>
    );
  }
  return <div className="space-y-2 max-h-[560px] overflow-y-auto pr-1 md:pr-12" data-testid="patient-messages-tab">{msgs.map((m) => <Msg key={m.id} m={m} />)}</div>;
};

export default PatientMessagesTab;
